import _, { find, some } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getProductPriceTitle } from "@/helpers";
import { isIPad, isMobile } from "@/helpers/variables";

export default {
  name: "ProductPriceNew",
  props: {
    clientPrices: {
      required: true,
      default: () => [],
    },
    selectedProductPrice: {
      required: true,
      type: Object,
    },
    product: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showTimer: false,
      timeRemaining: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      timerInterval: null,
      isExpired: false,
    };
  },
  watch: {
    selectedProductPrice(val) {
      this.clearTimer();
      this.showTimer = !!val.promotion;
      if (val.promotion && val.promotion.activities) {
        this.$nextTick(() => {
          this.startTimer();
        });
      }
    },
  },
  mounted() {
    this.showTimer = !!this.selectedProductPrice.promotion;
    if (this.selectedProductPrice.promotion && this.selectedProductPrice.promotion.activities) {
      this.$nextTick(() => {
        this.startTimer();
      });
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  computed: {
    ...mapGetters({
      isManager: "profile/isManager",
      productLoading: "card/productLoading",
      product: "card/product",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      isUserWithCode: "profile/isUserWithCode",
      favourites: "favorites/whichList",
      basket: "basket/basket",
      productsWithDefaultPrices: "basket/productsWithDefaultPrices",
      user: "profile/user",
      isAuthenticated: "auth/isAuthenticated",
      showNotifyLoader: "products/showNotifyLoader",
      currentRegion: "regions/currentRegion",
    }),
    currentSelectProductPrice() {
      const volume = parseInt(this.$route.query.value);

      return this.product.productPrices.data.find(item => {
        return item.value == volume;
      });
    },
    clientPriceTypeName() {
      return this.isProfessional ? this.$t("patient") : this.$t("cosmetologist");
    },
    isRegularUser() {
      return !(this.isUserWithCode || this.isProfessional || this.isDistributor);
    },
    isOtherRegion() {
      return localStorage.getItem("country") === "OTHER";
    },
    formattedTimeRemaining() {
      if (this.isExpired) {
        return null;
      }
      const { days, hours, minutes, seconds } = this.timeRemaining;

      // Hide timer if everything is 0
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        return null;
      }

      const pluralizeDays = (days) => {
        const mod10 = days % 10;
        const mod100 = days % 100;
        if (mod10 === 1 && mod100 !== 11) return `${days} день`;
        if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return `${days} дні`;
        return `${days} днів`;
      };

      if (days === 0) {
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      return `${pluralizeDays(days)} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },
  methods: {
    getProductPriceTitle,
    isOutlet(productPrice) {
      return (
        productPrice.outletReasons && productPrice.outletReasons.data && productPrice.outletReasons.data.length > 0
      );
    },
    isRefill(productPrice) {
      return productPrice.isRefill;
    },
    isWithoutBox(productPrice) {
      return productPrice.withoutBox;
    },
    professionalHasDiscount() {
      return (this.isProfessional || this.isDistributor) && this.productHasDiscountForSomePrice();
    },
    priceHasDiscountForProfessional(productPrice) {
      /*todo - isDistributor*/
      if (!(this.isProfessional || this.isDistributor)) {
        return false;
      }

      return productPrice.hasIndividualDiscount || productPrice.hasActivePromotion;
    },
    showClientPriceColumn() {
      if (this.isProfessional || this.isDistributor) {
        if (this.clientPrices && Array.isArray(this.clientPrices)) {
          return this.clientPrices.some(price => price?.typeVisible);
        }
      }
      return false;
    },
    formatCurrentPriceValue(field) {
      if (this.selectedProductPrice && !this.selectedProductPrice.typeVisible) return "";
      if (!this.selectedProductPrice) return "";
      return this.selectedProductPrice[field] + ` грн`;
    },
    productHasDiscountForSomePrice() {
      if (this.isProfessional || this.isDistributor) {
        return some(
          this.product.productPrices.data,
          productPrice => productPrice.hasIndividualDiscount || productPrice.hasActivePromotion
        );
      }

      return some(this.product.productPrices.data, productPrice => productPrice.hasActivePromotion);
    },

    /**
     * @param {ProductPrice} productPrice
     * @return {boolean}
     */
    showClientPrice(productPrice) {
      /*todo - isDistributor*/
      return (
        (this.isProfessional || this.isDistributor) &&
        some(this.clientPrices, clientPrice => clientPrice.value === productPrice.value && clientPrice.typeVisible)
      );
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getBasePriceForUser(productPrice) {
      if (this.isUserWithCode) {
        const clientProductPrice = find(this.clientPrices, price => price.value === productPrice.value);

        if (!clientProductPrice) {
          return "0";
        }

        return clientProductPrice.price.toFixed(2);
      }

      if (this.priceHasDiscountForProfessional(productPrice)) {
        return productPrice.oldPrice.toFixed(2);
      }

      return "0";
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getClientPrice(productPrice) {
      const response = Number(
        productPrice.clientPrice && productPrice.clientPrice !== 0 ? productPrice.clientPrice : productPrice.price
      )?.toFixed(2);
      console.log(response);
      return response;
    },
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.$emit("change-product", productPrice);
      if (!this.leftoverType) {
        this.leftoverType = productPrice.leftoverType.data;
      }

      this.selectedProductPrice = productPrice;

      if (this.isSelectedPrice(productPrice)) {
        return;
      }

      this.leftoverType = productPrice.leftoverType.data;

      this.setSelectedCount(this.selectedCount, productPrice);
      this.setPriceValueToQuery(productPrice.value);
    },
    setSelectedCount(count, productPrice = null) {
      this.selectedCount = 0;
      const setQuantity = Math.min(
        Math.max(Number.parseFloat(count || "1"), 1),
        (productPrice || this.selectedProductPrice).quantity
      );

      return (this.selectedCount = Math.ceil(setQuantity));
    },
    setPriceValueToQuery(value) {
      this.$router.replace({ query: { value } });
    },
    isSelectedPrice(productPrice) {
      const isValueSame = parseInt(this.$route.query.value) === parseInt(productPrice.value);
      const isIdSame = this.selectedProductPrice.id === productPrice.id;
      return isIdSame && isValueSame;
    },
    isMobile() {
      return isMobile.any() || isIPad.iOS();
    },
    /**
     * Get the full activity range from all activities
     * @returns {{ dateFrom: Date, dateTo: Date } | null}
     */
    getFullActivityRange() {
      if (!this.selectedProductPrice.promotion?.activities?.data) {
        return null;
      }

      const activities = this.selectedProductPrice.promotion.activities.data;
      if (activities.length === 0) {
        return null;
      }

      let earliestFrom = null;
      let latestTo = null;

      activities.forEach(activity => {
        const dateFrom = this.parseActivityDate(activity.dateFrom);
        const dateTo = this.parseActivityDate(activity.dateTo);

        if (!earliestFrom || dateFrom < earliestFrom) {
          earliestFrom = dateFrom;
        }
        if (!latestTo || dateTo > latestTo) {
          latestTo = dateTo;
        }
      });

      return { dateFrom: earliestFrom, dateTo: latestTo };
    },
    /**
     * Parse activity date string to Date object
     * Format: "2025-11-03 00:00:00"
     * @param {string} dateString
     * @returns {Date}
     */
    parseActivityDate(dateString) {
      const [date, time] = dateString.split(' ');
      const [year, month, day] = date.split('-').map(Number);
      const [hours, minutes, seconds] = time.split(':').map(Number);

      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    /**
     * Calculate time remaining until the end of activities
     */
    calculateTimeRemaining() {
      const activityRange = this.getFullActivityRange();

      if (!activityRange) {
        this.isExpired = true;
        this.showTimer = false;
        return;
      }

      const now = new Date();
      const { dateFrom, dateTo } = activityRange;

      if (now < dateFrom) {
        this.isExpired = true;
        this.showTimer = false;
        return;
      }

      const timeDiff = dateTo.getTime() - now.getTime();

      if (timeDiff <= 0) {
        this.isExpired = true;
        this.showTimer = false;
        this.timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
        return;
      }

      // Calculate remaining time
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.timeRemaining = { days, hours, minutes, seconds };
      this.isExpired = false;
    },
    /**
     * Start the countdown timer
     */
    startTimer() {
      this.calculateTimeRemaining();

      if (!this.isExpired) {
        this.timerInterval = setInterval(() => {
          this.calculateTimeRemaining();
        }, 1000);
      }
    },
    /**
     * Clear the timer interval
     */
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
  },
};
